(function() { window.GUID_bd269e9b_a075_4d15_8987_1846020ee2be = { getGuid: function() { return "bd269e9b-a075-4d15-8987-1846020ee2be"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class ProgressBar extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return this.$control;
            }
            OnControlInstantiation(params) {
                const me = this;
                me.controlId = params[0];
                me.$control = $('#' + params[0]);
                me.$background = me.$Control.find(".background");
                me.$progress = me.$Control.find(".progress");
                me.value = params[1];
                me.range = params[2];
                const fillPercentage = Math.round(me.value * 100 / me.range);
                me.$progress.css({
                    width: `${fillPercentage}%`
                });
            }
            OnBindEvents() {
            }
            OnDispose() {
            }
        }
        Controls.ProgressBar = ProgressBar;
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=progress-bar.js.map
